<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-11-02 10:43:45
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveType\editLeaveType.vue
 -->
<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_leaveType_form_editTitle')
        : $t('label_essweb_leaveType_form_viewTitle')
    "
    widthClass="max-1000"
    pad="0"
    delBtn
    :initData="LeaveTypeData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'leave_type_name',
      'color_code',
      'sequence',
      'unit',
      'remarks',
      'leave_type_abbr',
      'leave_type_property_group_uuid',
      'leave_type_description',
    ]"
    :editBtn="!iSEdited"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_leaveType_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber :curTab="curTab" @change="(tab) => (curTab = tab)" :items="taber">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  maxlength="100"
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="LeaveTypeData.leave_type_name"
                  @change="
                    (valueArr) => {
                      LeaveTypeData.leave_type_name = valueArr;
                    }
                  "
                  :label="$t('label_essweb_leaveType_form_leaveTypeNameLabel')"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  maxlength="20"
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :bindData="LeaveTypeData.leave_type_abbr"
                  @change="
                    (valueArr) => {
                      LeaveTypeData.leave_type_abbr = valueArr;
                    }
                  "
                  :label="$t('label_essweb_leaveType_form_leaveTypeAbbrLabel')"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  isNotRequire
                  type="number"
                  maxlength="255"
                  :rules="
                    $GetRules(
                      ['_Number_negative', '_Length_Rules'],
                      [null, 255]
                    )
                  "
                  :label="$t('label_essweb_leaveType_form_sequenceLabel')"
                  v-model="LeaveTypeData.sequence"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_leaveType_form_unitLabel")
                }}</v-sheet>
                <v-select
                  v-model="LeaveTypeData.unit"
                  :items="Units"
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  item-value="value_field"
                  item-text="view_fields"
                  single-line
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  :rules="$GetRules('_Require_Rules', [null])"
                  dense
                  :label="$t('label_essweb_leaveType_form_unitLabel')"
                >
                  <template v-slot:no-data> <noContent /> </template>

                  <template v-slot:selection="{ item, index }">
                    {{ $getCommonLangValue(item.view_fields) }}
                  </template>
                  <template v-slot:item="{ item, index }">
                    {{ $getCommonLangValue(item.view_fields) }}
                  </template>
                </v-select>
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :label="
                    $t(
                      'label_essweb_leaveTransactionPropertyGroup_form_codeLabel'
                    )
                  "
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :rules="$GetRules('_Require_Rules', [null])"
                  maxlength="50"
                  v-model="LeaveTypeData.leave_type_code"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="LeaveTypeData.leave_type_description"
                  @change="
                    (valueArr) => {
                      LeaveTypeData.leave_type_description = valueArr;
                    }
                  "
                  :label="$t('label_essweb_leaveType_form_descriptionLabel')"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_leaveType_form_leaveTypePropertyGroupLabel")
                }}</v-sheet>
                <v-autocomplete
                  v-model="LeaveTypeData.leave_type_property_group_uuid"
                  :items="propertyGroup"
                  item-value="uuid"
                  item-text="leave_type_property_group_name"
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  :filled="iSEdited"
                  single-line
                  :readonly="!iSEdited"
                  :rules="$GetRules('_Require_Rules', [null])"
                  dense
                  :label="
                    $t(
                      'label_essweb_leaveType_form_leaveTypePropertyGroupLabel'
                    )
                  "
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-autocomplete>
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_leaveType_form_tagColorLabel")
                }}</v-sheet>
                <SelectColor
                  :items="Colors"
                  v-model="LeaveTypeData.color_code"
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :appendIcon="iSEdited ? 'arrow_drop_down' : ''"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_leaveType_form_remarkLabel")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  :filled="iSEdited"
                  single-line
                  :readonly="!iSEdited"
                  dense
                  counter="500"
                  v-model="LeaveTypeData.remarks"
                  name="input-7-4"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-container fluid class="mrc-grey rounded-lg">
            <!-- <draggable
              v-model="dragArr"
              draggable=".drag"
              v-bind="{ animation: 1000 }"
              :list="leave_type_notice"
            >-->
            <v-sheet
              class="rounded-lg pa-0 drag mt-2 mb-2"
              v-for="(item, index) in leave_type_notice"
              :key="index"
            >
              <v-hover v-slot:default="{ hover }" open-delay="100">
                <v-card
                  class="pa-2 d-flex rounded-lg align-center"
                  :elevation="hover ? 4 : 2"
                >
                  <!-- bug847 mel -->
                  <!-- <svg-icon
                    size="36"
                    fill="grey"
                    iconClass="dragvertical"
                    style="min-width: 36px"
                  /> -->
                  <svg-icon
                    size="36"
                    fill="black"
                    iconClass="arrow01"
                    style="min-width: 36px"
                  />
                  <span class="text-body-2">
                    {{
                      $getCommonLangValue(
                        item["leave_type_notice_point_" + item.number]
                      )
                    }}
                  </span>
                  <v-spacer></v-spacer>
                  <!-- <v-btn icon v-if="hover">
                      <span class="material-icons-round">
                visibility
              </span>
                  </v-btn>-->
                  <v-btn
                    icon
                    small
                    v-if="hover && iSEdited"
                    @click="toEditNotice(item)"
                    :disabled="!iSEdited"
                  >
                    <span class="material-icons-round">edit</span>
                  </v-btn>
                  <v-btn
                    icon
                    :disabled="!iSEdited"
                    small
                    v-if="hover && iSEdited"
                    @click="onDeleteNotice(item)"
                  >
                    <span class="material-icons-round">delete</span>
                  </v-btn>
                </v-card>
              </v-hover>
            </v-sheet>
            <!-- </draggable> -->
          </v-container>
        </template>
        <template v-slot:content-3>
          <Tabler
            :headers="headers"
            :items="leave_transaction_type"
            border
            :avPerPage="50"
          >
            <template v-slot:item.name="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.leave_transaction_type_name) }}
              </div>
            </template>
            <template v-slot:item.code="{ item }">
              <div class="table-title text--primary">
                {{ item.leave_transaction_type_common_code }}
              </div>
            </template>
            <template v-slot:item.type="{ item }">
              <div class="table-title text--primary">
                {{ $getCommonLangValue(item.leave_type_name) }}
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                v-if="iSEdited"
                small
                :disabled="!iSEdited"
                @click="
                  curTranTypeUuid = item.uuid;
                  showEditTranType = true;
                "
              >
                <span class="material-icons-round">edit</span>
              </v-btn>
              <v-btn
                icon
                small
                v-if="iSEdited"
                @click="toDeleteTransactionType(item.uuid)"
                :disabled="!iSEdited"
              >
                <span class="material-icons-round">delete</span>
              </v-btn>
            </template>
            <template v-slot:footer>
              <v-container fluid class="pa-0">
                <v-divider v-if="iSEdited"></v-divider>
                <v-btn
                  text
                  small
                  v-if="iSEdited"
                  class="my-2 text-capitalize"
                  color="primary"
                  @click="showNewTranType = true"
                >
                  {{
                    $t(
                      "label_essweb_leaveType_form_dialog_addLeaveTransactionTypeBtnLabel"
                    )
                  }}
                  <span class="material-icons-round">add</span>
                </v-btn>
              </v-container>
            </template>
          </Tabler>
        </template>
        <template v-slot:content-4>
          <v-card :elevation="0" class="pa-0">
            <v-card-text class="pa-0">
              <Tabler
                :headers="headers2"
                :showNoContent="false"
                :items="desserts2"
              >
                <template v-slot:item.holiday_type_name="{ item }">{{
                  $getCommonLangValue(item.holiday_type_name)
                }}</template>
                <template v-slot:item.holiday_type_code="{ item }">{{
                  item.holiday_type_code
                }}</template>
              </Tabler>
            </v-card-text>
            <v-card-actions class="pb-0 pl-0">
              <v-btn
                text
                color="primary"
                v-if="iSEdited"
                small
                class="text-capitalize mb-3"
                @click="toEditMapping"
              >
                {{ $t("label_essweb_leaveType_form_editHolidayTypeBtnLabel") }}
                <span class="material-icons-round">add</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </Taber>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        :saveBtn="curTab == 'tab-1'"
        v-if="iSEdited && curTab == 'tab-1'"
        @save="toSave"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <editNotice
        :show="showEditNotice"
        @close="
          showEditNotice = false;
          NoticePropertyData = null;
        "
        :PropertyData="NoticePropertyData"
        @onEdit="onEditNotice"
      />
      <newTransactionType
        :show="showNewTranType"
        @close="showNewTranType = false"
        @onNew="onNewTranType"
      />
      <editTransactionType
        :show="showEditTranType"
        :curUuid="curTranTypeUuid"
        @close="
          showEditTranType = false;
          curTranTypeUuid = null;
        "
        @onEdit="onEditTranType"
      />
      <editHolidayType
        :show="mapToDiag"
        :PorpertyData="curPorperty"
        @editPorperty="onEditProperty"
        @close="mapToDiag = false"
      />
    </template>
  </ContentLayout>
</template>
<script>
import editNotice from "@/Page/EssAdmin/Leave/LeaveType/components/editNotice";
import newTransactionType from "@/Page/EssAdmin/Leave/LeaveType/components/newTransactionType";
import editTransactionType from "@/Page/EssAdmin/Leave/LeaveType/components/editTransactionType";
import editHolidayType from "@/Page/EssAdmin/Leave/LeaveType/components/editHolidayType";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
export default {
  name: "editLeaveType",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  components: {
    draggable,
    editNotice,
    editTransactionType,
    newTransactionType,
    editHolidayType,
  },
  data() {
    return {
      iSEdited: true,
      mapToDiag: false,
      curPorperty: [],
      Colors: [],
      curTab: "tab-1",
      isChanged: false,
      dragArr: [],
      showSelect: false,
      curTranTypeUuid: null,
      showTranTypeDelete: false,
      showNewTranType: false,
      showEditTranType: false,
      willClearNotice: null,
      willClearNoticeuuid: null,
      curNoticeUuid: null,
      NoticePropertyData: null,
      showEditNotice: false,
      Units: [],
      taber: [
        "label_essweb_leaveType_form_step_generalLabel",
        "label_essweb_leaveType_form_step_noticeLabel",
        "label_essweb_leaveType_form_step_leaveTransactiontypeLabel",
        "label_essweb_leaveType_form_step_HolidayTypeLabel",
      ],
      leave_type_notice: [],
      leave_transaction_type: [],
      LeaveTypeData: {
        leave_type_name: "",
        color_code: "",
        sequence: 1,
        unit: "",
        remarks: "",
        leave_type_code: "",
        leave_type_abbr: "",
        leave_type_property_group_uuid: "",
        leave_type_description: "",
      },
      propertyGroup: [],
      headers: [
        {
          text: "label_essweb_leaveType_form_leaveTransactionTypeNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveType_form_leaveTransactionTypeCodeLabel",
          value: "code",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveType_form_leaveTypeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      holidayUuids: [],
      desserts: [],
      headers2: [
        {
          text: "label_essweb_holidayType_list_HolidayTypeNameLabel",
          value: "holiday_type_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holidayType_list_HolidayTypeCodeLabel",
          value: "holiday_type_code",
          align: "start",
          sortable: false,
        },
      ],
      desserts2: [],
    };
  },
  mounted() {
    //初始化
    // this.LeaveTypeData.leave_type_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.LeaveTypeData.leave_type_abbr = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.LeaveTypeData.leave_type_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getColors();
    this.getUnits();
    this.getLeavePropertyGroup();
    this.getDetail();
    this.getNotice();
    this.getTransactionType();
    this.getHolidayType();
  },
  watch: {
    desserts(val) {
      const that = this;
      that.holidayUuids = [];
      this.curPorperty = val;
      val.forEach(function (item) {
        that.holidayUuids.push(item.uuid);
      });
    },
  },
  methods: {
    toEditMapping: function () {
      const that = this;
      this.curPorperty = [];
      this.$Sleep(300).then(() => {
        that.curPorperty = that.desserts2;
      });
      this.mapToDiag = true;
    },
    onEditProperty(obj) {
      this.mapToDiag = false;
      const that = this;
      var newUuids = [];
      obj.forEach(function (item) {
        newUuids.push(item.uuid);
      });

      this.toEditHoliday(newUuids);
    },
    toEditHoliday: function (uuids) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type_map_holiday_type",
        url: "/leave-map-leave-type-and-holiday-type/update-table/",
        data: {
          leave_type_uuid: this.$route.params.id,
          latest_ids: uuids.join(","),
        },
      }).then((res) => {
        that.getHolidayType();
      });
    },
    getHolidayType() {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type_map_holiday_type",
        url: "/leave-map-leave-type-and-holiday-type/get-list/",
        data: {
          leave_type_uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.desserts2 = res.data;
      });
    },
    getColors() {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_color_leave_select",
      }).then((res) => {
        that.Colors = [];
        res.data.map((item) => {
          that.Colors.push({
            text: item.view_fields,
            color: item.value_field,
          });
        });
      });
    },
    getUnits: function () {
      this.$findPrompt({
        prompt_name: "ess_leaveT_unit_select",
      }).then((res) => {
        this.Units = res.data;
      });
    },
    getLeavePropertyGroup: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type_property_group",
        url: "/leave-type-property-group/get-list/",
        data: {},
      }).then((res) => {
        res.data.map((item) => {
          item.leave_type_property_group_name = that.$getCommonLangValue(
            item.leave_type_property_group_name
          );
        });
        that.propertyGroup = res.data;
      });
    },
    toEditNotice: function (obj) {
      this.NoticePropertyData = obj;
      this.showEditNotice = true;
    },
    onDeleteNotice: function (item) {
      const that = this;
      this.willClearNotice = item;
      this.$confirmDo(
        this.$t("label_essweb_leaveType_form_step_noticeLabel")
      ).then((res) => {
        if (res) that.toClearNotice();
      });
    },
    toClearNotice: function () {
      const that = this;
      let data = {
        uuid: this.willClearNotice["uuid"],
      };
      data["leave_type_notice_point_" + this.willClearNotice.number] =
        this.$transCommonLangKey(
          this.$getCommonLangKey(this.companyLang),
          this.willClearNotice[
            "leave_type_notice_point_" + this.willClearNotice.number + "_save"
          ]
        );

      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type_notice",
        url: "/leave-type-notice/update/",
        data: data,
      }).then((res) => {
        that.leave_type_notice.map((item) => {
          if (item.number == that.willClearNotice.number) {
            item["leave_type_notice_point_" + that.willClearNotice.number] =
              data["leave_type_notice_point_" + that.willClearNotice.number];
          }
        });
      });
    },

    onNewTranType: function (obj) {
      const that = this;
      this.showNewTranType = false;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type",
        url: "/leave-transaction-type/add/",
        data: {
          leave_transaction_type_name: this.$transCommonLangKey(
            obj.leave_transaction_type_name
          ),
          leave_transaction_type_description: this.$transCommonLangKey(
            obj.leave_transaction_type_description
          ),
          // over_balance_approval_flow_template_uuid:
          //   obj.over_balance_approval_flow_template_uuid, //bj 2021-07-05
          calculation_method: obj.calculation_method,
          is_default: Number(obj.is_default) ? 1 : 0,
          leave_transaction_type_code: obj.leave_transaction_type_code,
          leave_transaction_type_common_code:
            obj.leave_transaction_type_common_code,
          // approval_flow_template_uuid: obj.approval_flow_template_uuid,
          leave_transaction_type_property_group_uuid:
            obj.leave_transaction_type_property_group_uuid,
          leave_type_uuid: this.$route.params.id,
          sequence: obj.sequence,
          remarks: obj.remarks,
        },
      }).then((res) => {
        that.getTransactionType();
      });
    },
    onEditTranType: function (obj) {
      const that = this;
      this.showEditTranType = false;
      this.curTranTypeUuid = null;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type",
        url: "/leave-transaction-type/update/",
        data: {
          uuid: obj.uuid,
          leave_transaction_type_name: this.$transCommonLangKey(
            obj.leave_transaction_type_name,
            obj.leave_transaction_type_name_save
          ),
          leave_transaction_type_description: this.$transCommonLangKey(
            obj.leave_transaction_type_description,
            obj.leave_transaction_type_description_save
          ),
          // over_balance_approval_flow_template_uuid:
          //   obj.over_balance_approval_flow_template_uuid, //bj 2021-07-05
          calculation_method: obj.calculation_method,
          is_default: obj.is_default ? 1 : 0,
          leave_transaction_type_code: obj.leave_transaction_type_code,
          leave_transaction_type_common_code:
            obj.leave_transaction_type_common_code,
          // approval_flow_template_uuid: obj.approval_flow_template_uuid,
          leave_transaction_type_property_group_uuid:
            obj.leave_transaction_type_property_group_uuid,
          leave_type_uuid: obj.leave_type_uuid,
          sequence: obj.sequence,
          remarks: obj.remarks,
        },
      }).then((res) => {
        that.getTransactionType();
      });
    },
    getNotice: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type_notice",
        url: "/leave-type-notice/get-list/",
        data: {
          leave_type_uuid: this.$route.params.id,
        },
      }).then((res) => {
        // for (let i = 1; i <= 5; i++) {
        //   var temp = res.data[0];
        //   temp["number"] = i;
        //   temp["leave_type_notice_point_" + i + "_save"] =
        //     temp["leave_type_notice_point_" + i];
        //   that.leave_type_notice.push(temp);
        // }
        res.data[1] = JSON.parse(JSON.stringify(res.data[0]));
        res.data[2] = JSON.parse(JSON.stringify(res.data[0]));
        res.data[3] = JSON.parse(JSON.stringify(res.data[0]));
        res.data[4] = JSON.parse(JSON.stringify(res.data[0]));

        res.data[0]["number"] = 1;
        res.data[1]["number"] = 2;
        res.data[2]["number"] = 3;
        res.data[3]["number"] = 4;
        res.data[4]["number"] = 5;
        res.data.map((item, index) => {
          item["leave_type_notice_point_" + (index + 1) + "_save"] =
            item["leave_type_notice_point_" + (index + 1)];
          // item[
          //   "leave_type_notice_point_" + (index + 1)
          // ] = that.$transOnLineCommonLangKey(
          //   that.companyLang,
          //   item["leave_type_notice_point_" + (index + 1)]
          // );
        });

        that.leave_type_notice = res.data;
      });
    },
    getTransactionType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type",
        url: "/leave-transaction-type/get-list/",
        data: {
          leave_type_uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.leave_transaction_type = res.data;
      });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["leave_type_name_save"] = res.data.leave_type_name;
        res.data.leave_type_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.leave_type_name
        );
        res.data["leave_type_description_save"] =
          res.data.leave_type_description;
        res.data.leave_type_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.leave_type_description
        );
        res.data["leave_type_abbr_save"] = res.data.leave_type_abbr;
        res.data.leave_type_abbr = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.leave_type_abbr
        );
        this.LeaveTypeData = res.data;
      });
    },
    onEditNotice: function (obj, number) {
      const that = this;
      that.NoticePropertyData = null;
      let data = {
        uuid: obj.uuid,
      };
      data["leave_type_notice_point_" + number] =
        obj["leave_type_notice_point_" + number];
      this.showEditNotice = false;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type_notice",
        url: "/leave-type-notice/update/",
        data: data,
      }).then((res) => {
        that.leave_type_notice.map((item) => {
          if (item.number == number) {
            item["leave_type_notice_point_" + number] =
              obj["leave_type_notice_point_" + number];
          }
        });
      });
    },
    toSave: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/update/",
        data: {
          uuid: this.$route.params.id,
          unit: this.LeaveTypeData.unit,
          leave_type_name: this.$transCommonLangKey(
            this.LeaveTypeData.leave_type_name,
            this.LeaveTypeData.leave_type_name_save
          ),
          leave_type_description: this.$transCommonLangKey(
            this.LeaveTypeData.leave_type_description,
            this.LeaveTypeData.leave_type_description_save
          ),
          leave_type_abbr: this.$transCommonLangKey(
            this.LeaveTypeData.leave_type_abbr,
            this.LeaveTypeData.leave_type_abbr_save
          ),
          leave_type_code: this.LeaveTypeData.leave_type_code,
          color_code: this.LeaveTypeData.color_code,
          remarks: this.LeaveTypeData.remarks,
          sequence: this.LeaveTypeData.sequence,
          leave_type_property_group_uuid:
            this.LeaveTypeData.leave_type_property_group_uuid,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_leaveType_list_updateLeaveTypeSuccessLabel"
          ),
          type: "success",
        });
        that.$toBack();
      });
    },
    toDeleteTransactionType: function (uuid) {
      const that = this;
      this.curTranTypeUuid = uuid;
      this.$confirmDo(
        this.$t("label_essweb_leaveType_form_step_leaveTransactiontypeLabel")
      ).then((res) => {
        if (res) that.onDeleteTranType();
      });
    },
    onDeleteTranType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type",
        url: "/leave-transaction-type/delete/",
        data: {
          uuids: this.curTranTypeUuid,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_leaveType_list_deleteLeaveTransTypeSuccessLabel"
          ),
          type: "success",
        });
        that.leave_transaction_type = that.leave_transaction_type.filter(
          (ele) => ele.uuid !== that.curTranTypeUuid
        );
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_type",
        url: "/leave-type/delete/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_leaveType_list_deleteLeaveTypeSuccessLabel"
          ),
          type: "success",
        });
        that.$toBack();
      });
    },
  },
};
</script>
